<template>
  <div id="app">

    <transition name="router-fade" >
      <keep-alive>
        <router-view include="productList" v-if='$route.meta.keepAlive' v-wechat-title="$route.meta.title"></router-view>
      </keep-alive>
    </transition>

    <transition name="router-fade" >
      <router-view v-if='!$route.meta.keepAlive' v-wechat-title="$route.meta.title"></router-view>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  @import './style/style.css';

  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
    opacity: 0
  }
  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .5s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue